import * as React from "react";
import { useEffect, useMemo, useState } from "react";
import { useRemoteVideoStreamsStore } from "../../../../store/remote-video-streams.store";
import { useParticipantsStore } from "../../../../store/participants.store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
// TODO: Check which parts of this component can be combined with ParticipantListItem.component.tsx
export function ConferenceViewItem({ user, speaking }) {
    const remoteVideoStreams = useRemoteVideoStreamsStore();
    const users = useParticipantsStore();
    const [screenShareIsMain, setScreenShareIsMain] = useState(true);
    const [screenStreams, setScreenStreams] = useState(remoteVideoStreams.remoteScreenStreams);
    const [selectedScreenStream, setSelectedScreenStream] = useState();
    const { t } = useTranslation();
    useEffect(() => {
        const screenStreams = remoteVideoStreams.remoteScreenStreams.filter((s) => s.clientId === user.clientId);
        setScreenStreams(screenStreams);
        if (screenStreams.length <= 0) {
            setSelectedScreenStream(undefined);
        }
        else if ((selectedScreenStream == null) || (screenStreams.find((s) => s.stream === selectedScreenStream.stream) == null)) {
            setSelectedScreenStream(screenStreams[0]);
        }
    }, [remoteVideoStreams]);
    const selectPreviousScreenStream = () => {
        var _a;
        if (selectedScreenStream == null) {
            return;
        }
        const index = screenStreams.findIndex((s) => s.stream === selectedScreenStream.stream);
        if (index < 0) {
            return;
        }
        const newStream = index === 0 ? screenStreams[screenStreams.length - 1] : screenStreams[index - 1];
        setSelectedScreenStream(newStream);
        if (((_a = remoteVideoStreams.openedScreenStream) === null || _a === void 0 ? void 0 : _a.clientId) === user.clientId) {
            remoteVideoStreams.setOpenedScreenStream(newStream);
        }
    };
    const selectNextScreenStream = () => {
        var _a;
        if (selectedScreenStream == null) {
            return;
        }
        const index = screenStreams.findIndex((s) => s.stream === selectedScreenStream.stream);
        if (index < 0) {
            return;
        }
        const newStream = index === screenStreams.length - 1 ? screenStreams[0] : screenStreams[index + 1];
        setSelectedScreenStream(newStream);
        if (((_a = remoteVideoStreams.openedScreenStream) === null || _a === void 0 ? void 0 : _a.clientId) === user.clientId) {
            remoteVideoStreams.setOpenedScreenStream(newStream);
        }
    };
    const userAvatarScreenshare = () => {
        var _a, _b, _c, _d, _e, _f;
        let mainStream = null;
        let subStream;
        if (screenShareIsMain) {
            mainStream = (_a = selectedScreenStream === null || selectedScreenStream === void 0 ? void 0 : selectedScreenStream.stream) !== null && _a !== void 0 ? _a : null;
            subStream = (_c = (_b = remoteVideoStreams.remoteCameraStreams.find((s) => s.clientId === user.clientId)) === null || _b === void 0 ? void 0 : _b.stream) !== null && _c !== void 0 ? _c : null;
        }
        else {
            mainStream = (_e = (_d = remoteVideoStreams.remoteCameraStreams.find((s) => s.clientId === user.clientId)) === null || _d === void 0 ? void 0 : _d.stream) !== null && _e !== void 0 ? _e : null;
            subStream = (_f = selectedScreenStream === null || selectedScreenStream === void 0 ? void 0 : selectedScreenStream.stream) !== null && _f !== void 0 ? _f : null;
        }
        return (React.createElement("div", { className: "conference-view-item-shared-stream" },
            React.createElement("div", { className: "conference-view-item-mainstream-container" },
                React.createElement("video", { id: `conference-view-item-screen-${user.clientId}`, autoPlay: true, playsInline: true, muted: true, ref: (ref) => {
                        if (ref != null)
                            ref.srcObject = mainStream;
                    }, className: "conference-view-item-mainstream" }),
                React.createElement(React.Fragment, null,
                    screenShareIsMain && screenStreams.length > 1 && (React.createElement("div", { className: "conference-view-item-screenshare-previous", onClick: selectPreviousScreenStream, "data-tooltip": t("userlist:conference-item-button-prev-shared-screen-tooltip", "Previous shared screen") },
                        React.createElement(FontAwesomeIcon, { icon: ["fas", "angle-left"] }))),
                    React.createElement("button", { className: "icon-button-large conference-view-item-maximize-button", onClick: () => {
                            remoteVideoStreams.setOpenedScreenStream(screenShareIsMain
                                ? selectedScreenStream
                                : remoteVideoStreams.remoteCameraStreams.find((s) => s.clientId === user.clientId));
                        }, "data-tooltip": t("userlist:conference-item-button-open-shared-screen-tooltip", "Open this shared screen") },
                        React.createElement(FontAwesomeIcon, { icon: ["fas", "external-link-alt"] })),
                    (subStream != null) && (React.createElement("button", { className: "icon-button-large conference-view-item-toggle-stream-button", onClick: () => { setScreenShareIsMain((prev) => !prev); }, "data-tooltip": screenShareIsMain
                            ? t("userlist:conference-item-switch-to-camera", "Show camera stream")
                            : t("userlist:conference-item-switch-to-screen", "Show shared screen") },
                        React.createElement(FontAwesomeIcon, { icon: ["fas", screenShareIsMain ? "video" : "desktop"] }))),
                    screenShareIsMain && screenStreams.length > 1 && (React.createElement("div", { className: "conference-view-item-screenshare-next", onClick: selectNextScreenStream, "data-tooltip": t("userlist:conference-item-button-next-shared-screen-tooltip", "Next shared screen") },
                        React.createElement(FontAwesomeIcon, { icon: ["fas", "angle-right"] }))))),
            (subStream !== null) && (React.createElement("div", { className: "conference-view-item-substream-container" },
                React.createElement("video", { id: `conference-view-item-camera-${user.clientId}`, autoPlay: true, playsInline: true, muted: true, ref: (ref) => {
                        if (ref !== null)
                            ref.srcObject = subStream;
                    }, className: "conference-view-item-substream" })))));
    };
    const userAvatarCamera = () => {
        var _a;
        const cameraStream = remoteVideoStreams.remoteCameraStreams.find((s) => s.clientId === user.clientId);
        const stream = (_a = cameraStream === null || cameraStream === void 0 ? void 0 : cameraStream.stream) !== null && _a !== void 0 ? _a : null;
        return (React.createElement("div", { className: "conference-view-item-mainstream-container" },
            React.createElement("video", { id: `conference-view-item-camera-${user.clientId}`, autoPlay: true, playsInline: true, muted: true, ref: (ref) => {
                    if (ref != null)
                        ref.srcObject = stream;
                }, className: "conference-view-item-mainstream" }),
            React.createElement("button", { className: "icon-button-large conference-view-item-maximize-button", onClick: () => { remoteVideoStreams.setOpenedScreenStream(cameraStream); }, "data-tooltip": t("userlist:conference-item-button-open-shared-screen-tooltip", "Open this shared screen") },
                React.createElement(FontAwesomeIcon, { icon: ["fas", "external-link-alt"] }))));
    };
    const userAvatarDummy = () => { var _a; return React.createElement("img", { src: ((_a = user.avatar) === null || _a === void 0 ? void 0 : _a.imageUrl) || "img/avatars/defaultUserImage.jpeg", alt: "Avatar" }); };
    const userAvatar = useMemo(() => {
        if (screenStreams.length > 0) {
            return userAvatarScreenshare();
        }
        else if (remoteVideoStreams.remoteCameraStreams.find((s) => s.clientId === user.clientId) !== null) {
            return userAvatarCamera();
        }
        else {
            return userAvatarDummy();
        }
    }, [user, remoteVideoStreams, screenShareIsMain, screenStreams, selectedScreenStream]);
    const userNameString = useMemo(() => {
        const result = user.customUsername;
        if (users.mutedUsers.find((u) => u === user) !== null) {
            return String(result) + " " + t("userlist:conference-item-username-suffix-muted", "(muted)");
        }
        return result;
    }, [users]);
    return (React.createElement("div", { className: `conference-view-item ${speaking ? "conference-view-item-speaking" : ""}` },
        userAvatar,
        React.createElement("div", { className: "conference-view-item-name" }, userNameString)));
}
